module.exports = __webpack_public_path__ + "static/img/UTSC老师_Stephan.7974ed7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC老师_Stephan.png
// module id = eZ+e
// module chunks = 0